import React from "react";

const Washing_16 = React.forwardRef(
  ({ width = "32", height = "32", viewBox = "0 0 32 32", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30 2H2V30H30V2ZM0 0V32H32V0H0Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_16;
